import axios from "axios";


export async function axiosPostBlob(toUrl, data) {
    let hdr =
    {
        responseType: "blob"
    };
    return await axios.post("/api" + toUrl, data, hdr)
}

export async function axiosPost(toUrl, data) {
    return await axios.post("/api" + toUrl, data)
}

export async function axiosGet(toUrl) {
    return await axios.get("/api" + toUrl)
}